import { initUrqlClient, SSRData, withUrqlClient } from 'next-urql';
import { Client, defaultExchanges, ssrExchange } from 'urql';
import { operationNameExchange } from './operationNameExchange';

export function initUrqlClientForSSR(): {
  client: Client;
  extractCacheData: () => SSRData;
} {
  const ssrCache = ssrExchange({ isClient: false });
  const client = initUrqlClient(
    {
      url: process.env.INTERNAL_MACKEN_URL as string,
      exchanges: [operationNameExchange, ssrCache, ...defaultExchanges],
    },
    false,
  );
  if (client == null) {
    throw new Error('Failed to init urql client');
  }

  return { client, extractCacheData: () => ssrCache.extractData() };
}

export const withUrqlClientForSSR = withUrqlClient(
  () => ({
    url: process.env.NEXT_PUBLIC_MACKEN_URL as string,
  }),
  { ssr: false },
);
